"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "vicovaro": {
    "d0bf44d1": [{
      "hkey": "e7cdc043",
      "slug": "vicovaro",
      "name": "Vicovaro",
      "primary": true,
      "skipSearch": false
    }],
    "colle-frate": [{
      "hkey": "e7cdc043",
      "slug": "vicovaro",
      "name": "Vicovaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1f256e0a": [{
      "hkey": "04fe5c56",
      "slug": "sacco-muro",
      "name": "Sacco Muro",
      "primary": true,
      "skipSearch": false
    }],
    "saccomuro": [{
      "hkey": "04fe5c56",
      "slug": "sacco-muro",
      "name": "Sacco Muro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e61cd0a1": [{
      "hkey": "e7cdc043",
      "slug": "vicovaro",
      "name": "Vicovaro",
      "primary": true,
      "skipSearch": false
    }],
    "san-cosimato": [{
      "hkey": "e7cdc043",
      "slug": "vicovaro",
      "name": "Vicovaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;